const equipment_sizeall = ["43'", "48'", "40'", "28'", "10'"];
const StatusALL = ["ACTIVE", "OUT_OF_SERVICE", "UNDER_SERVICE'"];
const equipment_type_enum = [
  "DRY_VAN",

  "VAN_W/_TEAM",
  "VAN_AIR_RIDE",
  "VAN_HAZAHOUS",
  "VAN_VANTED",
  "VAN_W/CURTATINS",
  "VAN_W/PALLET_EXCHANGE",
  "TEAM_CONTROL",
  "REEFER",
  "REEFER_HAZADOUS",
  "REFER_W/PALLET_EXCHANGE",
  "VANOR_REEFER",
  // "FLATBED",
  "DOUBLE_DROP",
  "FLATBED",
  "FLATBED_CONESTOGA",
  "FLATBED-HAZRDOUS",
  "FLATBED_W/PALLET_EXCHANGE",
"FLATEBED W/SIDES",
  "LOWBOY",
  "MAXI",
  "REMOVIABLE_GOOSENECK",
  "CONESTOGA",
  "SPECIALIZED",
  "AUTO_CARRIER",
  "DUMP_TRAILER",
  "HOPPER_BOTTOM",
  "HOTSPOT",
  "INTEMODEL",
  "TANKER",
 
  "CONTAINER_40",
  "LANDROLL",
  "TANKER_GASOLINE",
  "INTERMODAL_TANKER",
  "B_TRAINS",
  "CARGO_VAN",
  "TRUCK",
  "STRAIGHT_TRUCK",
  "FLEXIBLE_TYPE",
  "FLATBED/STEP_DECK",

  "MISC",
  "POWER_ONLY",
  "TOWY",
  null,
];
const equipmentTypeEnum = [
  "DRY_VAN",

  "VAN_W/_TEAM",
  "VAN_AIR_RIDE",
  "VAN_HAZAHOUS",
  "VAN_VANTED",
  "VAN_W/CURTATINS",
  "VAN_W/PALLET_EXCHANGE",
  "TEAM_CONTROL",
  "REEFER",
  "REEFER_HAZADOUS",
  "REFER_W/PALLET_EXCHANGE",
  "VANOR_REEFER",
  "DOUBLE_DROP",
  // "FLATBED",
  "FLATBED_CONESTOGA",
  "FLATBED-HAZRDOUS",
  "FLATBED_W/PALLET_EXCHANGE",
  "FLATEBED W/SIDES",
  "LOWBOY",
  "MAXI",

  "CONESTOGA",
  "SPECIALIZED",
  "AUTO_CARRIER",
  "DUMP_TRAILER",
  "HOPPER_BOTTOM",
  "HOTSPOT",
  "INTEMODEL",
  "TANKER",

  "CONTAINER_40",

  "LANDROLL",
  "TANKER_GASOLINE",
  "INTERMODAL_TANKER",
  "B_TRAINS",
  "CARGO_VAN",
  "TRUCK",
  "STRAIGHT_TRUCK",
  "FLEXIBLE_TYPE",
  "FLATBED/STEP_DECK",

  "MISC",
  "POWER_ONLY",
  "TOWY",
  null,
];

const loadstatus = [
  "QUATED",
  "ASSIGNED",
  "CANCELED",
  "TONU",
  "DISPATCHED",
  "PICKED_UP",
  "IN_TRANSIT",
  "DELIVERED",
  // "CLOSED",
];

const loadstatusdisplay: any = {
  QUATED: "QUATED",
  ASSIGNED: "ASSIGNED",
  CANCELED: "CANCELED",
  TONU: "TONU",
  DISPATCHED: "DISPATCHED",
  PICKED_UP: "PICKED UP",
  IN_TRANSIT: "IN TRANSIT",
  DELIVERED: "DELIVERED",
  // CLOSED: "CLOSED",
};


const statusColors: Record<string, string> = {
  QUATED: "#67d8d1",    
  ASSIGNED: "#b18134",

  CANCELED: "#ea181b",

  TONU: "#eaa418",  

  DISPATCHED: "#c018ea",  

  PICKED_UP: "#ea18a4",   

  IN_TRANSIT: "#0866ff",  
  DELIVERED: "#00a04c", 
  // CLOSED: "#FFD1C1"       
};


const statusColors_carrier: Record<string, string> = {
  INTERSTED: "#67d8d1",    
  PACKET_SENT: "#b18134",
  INSURANCE_EXPIRED:'#ea18a4',
  PACKET_COMPLETE: "#ea181b",

  DO_NOT_USE: "#eaa418",  





  PENDING: "#ea181b",  
  ACTIVE: "#00a04c",     
};









const status_Colors_drver: Record<string, string> = {
  INACTIVE: "#0866ff",
  PENDING: "#ea181b",
  ACTIVE: "#00a04c", 
    
};

const status_Colors_customer: Record<string, string> = {
  DNU: "#0866ff",
  PENDING: "#ea181b",
  ACTIVE: "#00a04c", 
    
};




const status_Colors_truck: Record<string, string> = {
  OUT_OFF_SERVICE: "#0866ff",
  // DELETE: "#ea181b",
  ACTIVE: "#00a04c", 
  UNDER_SERVICE:"#c018ea"
};

const status_Colors_trailer: Record<string, string> = {
  OUT_OF_SERVICE: "#0866ff",

  ACTIVE: "#00a04c", 
  UNDER_SERVICE:"#c018ea"
};




















const displayMappings: any = {
  DRY_VAN: "DRY VAN",

  "VAN_W/_TEAM": "Van with Team",
  VAN_AIR_RIDE: "Van Air Ride",
  VAN_HAZAHOUS: "Van Hazardous",
  VAN_VANTED: "Van Vented",
  "VAN_W/CURTATINS": "Van with Curtains",
  "VAN_W/PALLET_EXCHANGE": "Van with Pallet Exchange",
  TEAM_CONTROL: "Team Control",
  REEFER: "Reefer",
  REEFER_HAZADOUS: "Reefer Hazardous",
  "REFER_W/PALLET_EXCHANGE": "Reefer with Pallet Exchange",
  VANOR_REEFER: "Van or Reefer",
  // FLATBED: "Flatbed",
  DOUBLE_DROP: "Double Drop",
  FLATBED_CONESTOGA: "Flatbed Conestoga",
  "FLATBED-HAZRDOUS": "Flatbed Hazardous",
  "FLATBED_W/PALLET_EXCHANGE": "Flatbed with Pallet Exchange",
  "FLATEBED W/SIDES": "Flatbed with Sides",
  LOWBOY: "Lowboy",
  MAXI: "Maxi",
  REMOVIABLE_GOOSENECK: "Removable Gooseneck",
  CONESTOGA: "Conestoga",
  SPECIALIZED: "Specialized",
  AUTO_CARRIER: "Auto Carrier",
  DUMP_TRAILER: "Dump Trailer",
  HOPPER_BOTTOM: "Hopper Bottom",
  HOTSPOT: "Hotspot",
  INTEMODEL: "Intermodal",
  TANKER: "Tanker",
  "OPEN_DECK/SPECIALIIZED": "Open Deck/Specialized",
  CONTAINER_40: "Container 40",
  "Container REFER": "Container Reefer",
  LANDROLL: "Landroll",
  TANKER_GASOLINE: "Tanker Gasoline",
  INTERMODAL_TANKER: "Intermodal Tanker",
  B_TRAINS: "B Trains",
  CARGO_VAN: "Cargo Van",
  TRUCK: "Truck",
  STRAIGHT_TRUCK: "Straight Truck",
  FLEXIBLE_TYPE: "Flexible Type",
  "FLATBED/STEP_DECK": "Flatbed/Step Deck",
  "FALTEBED VAN": "Flatbed Van",
  MISC: "Miscellaneous",
  POWER_ONLY: "Power Only",
  TOWY: "Tow",
};

const stateOptions = [
  "AL", "AK", "AZ", "AR", "CA", "CO","CT", "DE", "FL", "GA", "HI", "ID", "IL", "IN", "IA", 
  "KS", "KY", "LA", "ME", "MD", "MA", "MI", "MN", "MS", "MO", "MT", "NE", "NV" ,"NM", "NH","NY", "NJ", 
   "NC", "ND", "OH", "OK","OR", "PA", "RI", "SC", "SD", "TN", "TX", "UT", "VT", 
  "VA", "WA", "WV", "WI", "WY",  
];





const equipment_enums = [
  "DRY_VAN",

  "VAN_W/_TEAM",
  "VAN_AIR_RIDE",
  "VAN_HAZAHOUS",
  "VAN_VANTED",
  "VAN_W/CURTATINS",
  "VAN_W/PALLET_EXCHANGE",
  "TEAM_CONTROL",
  "REEFER",
  "REEFER_HAZADOUS",
  "REFER_W/PALLET_EXCHANGE",
  "VANOR_REEFER",
  "DOUBLE_DROP",
  "FLATBED",
  "FLATBED_CONESTOGA",
  "FLATBED-HAZRDOUS",
  "FLATBED_W/PALLET_EXCHANGE",
  "FLATEBED W/SIDES",
  "LOWBOY",
  "MAXI",

  "CONESTOGA",
  "SPECIALIZED",
  "AUTO_CARRIER",
  "DUMP_TRAILER",
  "HOPPER_BOTTOM",
  "HOTSPOT",
  "INTEMODEL",
  "TANKER",
  "OPEN_DECK/SPECIALIIZED",
  "CONTAINER_40",
  "Container_REFER",
  "LANDROLL",
  "TANKER_GASOLINE",
  "INTERMODAL_TANKER",
  "B_TRAINS",
  "CARGO_VAN",
  "TRUCK",
  "STRAIGHT_TRUCK",
  "FLEXIBLE_TYPE",
  "FLATBED/STEP_DECK",
  "FALTEBED_VAN",
  "MISC",
  "POWER_ONLY",
  "TOWY",
  null,
];

const displayStatusALL:any = {ACTIVE:"ACTIVE", OUT_OF_SERVICE: "OUT OF SERVICE",UNDER_SERVICE:"faruk"}


const displayequipment_enums: any = {
  DRY_VAN: "DRY VAN",

  "VAN_W/_TEAM": "VAN W/ TEAM",
  VAN_AIR_RIDE: "VAN AIR RIDE",
  VAN_HAZAHOUS: "VAN HAZAHOUS",
  VAN_VANTED: "VAN VANTED",
  "VAN_W/CURTATINS": "VAN W/CURTAINS",
  "VAN_W/PALLET_EXCHANGE": "VAN W/PALLET EXCHANGE",
  TEAM_CONTROL: "TEAM CONTROL",
  REEFER: "REEFER",
  REEFER_HAZADOUS: "REEFER HAZADOUS",
  "REFER_W/PALLET_EXCHANGE": "REFER W/PALLET EXCHANGE",
  VANOR_REEFER: "VAN OR REEFER",
  DOUBLE_DROP: "DOUBLE DROP",
  // FLATBED: "FLATBED",
  FLATBED_CONESTOGA: "FLATBED CONESTOGA",
  FLATBED_HAZRDOUS: "FLATBED HAZARDOUS",
  "FLATBED_W/PALLET_EXCHANGE": "FLATBED W/PALLET EXCHANGE",
  "FLATBED_W/SIDES": "FLATBED W/ SIDES",
  LOWBOY: "LOWBOY",
  MAXI: "MAXI",
  "REMOVABLE GOOSENECK": "REMOVABLE GOOSENECK",
  CONESTOGA: "CONESTOGA",
  SPECIALIZED: "SPECIALIZED",
  AUTO_CARRIER: "AUTO CARRIER",
  DUMP_TRAILER: "DUMP TRAILER",
  HOPPER_BOTTOM: "HOPPER BOTTOM",
  HOTSPOT: "HOTSPOT",
  INTERMODEL: "INTERMODEL",
  TANKER: "TANKER",
  "OPEN_DECK/SPECIALIZED": "OPEN DECK/SPECIALIZED",
  CONTAINER_40: "CONTAINER 40",
  Container_REFER: "CONTAINER REFER",
  LANDROLL: "LANDROLL",
  TANKER_GASOLINE: "TANKER GASOLINE",
  INTERMODAL_TANKER: "INTERMODAL TANKER",
  B_TRAINS: "B TRAINS",
  CARGO_VAN: "CARGO VAN",
  TRUCK: "TRUCK",
  STRAIGHT_TRUCK: "STRAIGHT TRUCK",
  FLEXIBLE_TYPE: "FLEXIBLE TYPE",
  "FLATBED/STEP_DECK": "FLATBED/STEP DECK",
  "FALTEBED_VAN": "FLATBED VAN",
  MISC: "MISC",
  POWER_ONLY: "POWER ONLY",
  TOWY: "TOWY",
};




export {
  equipment_sizeall,
  StatusALL,
  equipment_type_enum,
  equipmentTypeEnum,
  displayMappings,
  stateOptions,
  loadstatus,
  loadstatusdisplay,
  equipment_enums,
  displayequipment_enums,
  displayStatusALL,
  statusColors,
  status_Colors_drver,
  status_Colors_truck,
  status_Colors_trailer,
  status_Colors_customer,
  statusColors_carrier
};










